import { useCallback, useState } from "react";
import { getSerials } from "../../../components/serials/functions";
import { useStableSearch } from "../../hooks/useStableSearch";

const DEFAULT_FILTERS = {
  q: "",
};

export function useSerialsSearch(user) {
  const [serials, setSerials] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [filters, setFilters] = useState(DEFAULT_FILTERS);

  const runSearch = useCallback(async ({ token, filters: activeFilters, isCurrent }) => {
    setLoading(true);
    setError(null);

    const { q } = activeFilters;
    const data = await getSerials(token, undefined, undefined, q);

    if (!isCurrent()) {
      return;
    }

    if (data?.type === "error") {
      setError(data);
      setSerials([]);
    } else if (data?.type === "success") {
      const rows = Array.isArray(data.data) ? data.data : [];
      setSerials(
        rows.map((item) => ({
          ...item,
          gradedAt: item.gradedAt ? new Date(item.gradedAt) : null,
        }))
      );
    } else {
      setSerials([]);
    }

    setLoading(false);
  }, []);

  const search = useStableSearch(user?.token, filters, runSearch);
  const refresh = useCallback(() => search(), [search]);

  return { serials, loading, error, filters, setFilters, search, refresh };
}
